import { render } from "./configuracaoInicial.vue?vue&type=template&id=796523ea&scoped=true"
import script from "./configuracaoInicial.vue?vue&type=script&lang=js"
export * from "./configuracaoInicial.vue?vue&type=script&lang=js"

import "./configuracaoInicial.vue?vue&type=style&index=0&id=796523ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796523ea"]])

export default __exports__